angular.module('dpw.components')

    .component('dpwEditProfileSecurityInfo', {
        templateUrl: 'dpw-edit-profile-security-info.html',
        controller: ['$scope', '$timeout', 'popupUtil', 'editProfileUtils', 'helpers',
            function ($scope, $timeout, popupUtil, editProfileUtils, helpers) {
                var $ctrl = this;
                initProfile();

                $ctrl.$onInit = function () {
                    $ctrl.formConfig = $ctrl.editProfileCtrl.formsConfig.securityInfo;

                    // TODO: Can be improved - Use a class to organize the fields.
                    $ctrl.fieldsConfig = {
                        oldPassword: {
                            fieldName: 'oldPassword',
                            keyName: 'oldPassword',
                            onChange: function () {
                                var fieldConfig = this;
                                $ctrl.editProfileCtrl.onFieldChange($ctrl.formConfig, fieldConfig, $ctrl);
                            },
                            errorHandler: [{
                                code: 'EXT-305',  // invalid old password
                                action: $ctrl.editProfileCtrl.buildHandlerAction($ctrl.formConfig)
                            }],
                            fieldErrors: [],
                            errorMessages: {
                                'EXT-305': RCDPW.Lang.EditProfile.INVALID_OLD_PASSWORD
                            }
                        },
                        newPassword: {
                            fieldName: 'newPassword',
                            keyName: 'newPassword',
                            onChange: function () {
                                var fieldConfig = this;
                                $ctrl.editProfileCtrl.onFieldChange($ctrl.formConfig, fieldConfig, $ctrl);
                            },
                            errorHandler: [],
                            fieldErrors: [],
                            errorMessages: {}
                        },
                        confirmPassword: {
                            fieldName: 'confirmPassword',
                            keyName: 'confirmPassword',
                            onChange: function () {
                                var fieldConfig = this;
                                $ctrl.editProfileCtrl.onFieldChange($ctrl.formConfig, fieldConfig, $ctrl);
                            },
                            fieldErrors: [],
                            errorMessages: {
                                'FRONT_END_VALIDATION_INVALID_CONFIRM_PASSWORD': RCDPW.Lang.MyAccount.ACCOUNT_INVALID_CONFIRM_PASSWORD
                            }
                        }
                    };
                };

                $ctrl.lang = RCDPW.Lang;

                $ctrl.onFieldFocus = function (fieldName) {
                    $ctrl.formConfig.setFieldStatus(fieldName, '$setUntouched');
                };

                $ctrl.submit = function () {
                    if (!isFormFullyFilled() || !isPasswordConfirmed() || !$ctrl.formConfig.getFormStatus('$valid')) {
                        $ctrl.formConfig.setFieldsStatus('$setTouched');
                        return;
                    }

                    var profile = editProfileUtils.profileAdapter($ctrl.profile, {
                        neededFields: ['oldPassword', 'newPassword']
                    });

                    editProfileUtils.changePassword(profile, function () {
                        initProfile();
                        $scope.$broadcast('dpwSaveStatus:showSavedStatus');
                        $ctrl.formConfig.setFormStatus('$setUntouched');
                    }, errorHandler);
                };

                function initProfile() {
                    $ctrl.profile = editProfileUtils.profileAdapter({}, {
                        neededFields: ['oldPassword', 'newPassword', 'confirmPassword']
                    });

                    $ctrl.originalProfile = _.cloneDeep($ctrl.profile);

                    $timeout(function () {
                        $ctrl.editProfileCtrl.dirtyCheck.perform($ctrl.formConfig, $ctrl);
                    });
                }

                function errorHandler(data, defaultErrorHandler) {
                    var handlerConfig = {
                        'EXT-306': function () {    // too many failed verification requests
                            popupUtil.ok({
                                content: RCDPW.Lang.MyAccount.PASSWORD_MULTIPLE_FAILURES
                            });
                        }

                        // Definitions for "Security Info" form go here.
                    };
                    var errorResult = helpers.resolveError(data);
                    if (errorResult.code === 'EXT-303' || errorResult.code === 'PLATFORM_ERROR_PWD') {
                        $ctrl.fieldsConfig.newPassword.errorMessages[errorResult.code] = errorResult.message;
                        $ctrl.fieldsConfig.newPassword.errorHandler = [{
                            code: errorResult.code,
                            action: $ctrl.editProfileCtrl.buildHandlerAction($ctrl.formConfig)
                        }];
                    }

                    _.assign(handlerConfig, editProfileUtils.extractHandlerConfig($ctrl.fieldsConfig));

                    $ctrl.editProfileCtrl.errorDispatcher(data, handlerConfig, defaultErrorHandler);
                }

                function isFormFullyFilled() {
                    var isFormFullyFilled = true;

                    _.forEach($ctrl.fieldsConfig, function (fieldConfig) {
                        var isFieldFilled = !_.isEmpty($ctrl.profile[fieldConfig.keyName]);
                        if (!isFieldFilled) {
                            $ctrl.editProfileCtrl.markFieldInvalid($ctrl.formConfig, fieldConfig, 'required');
                            isFormFullyFilled = false;
                        }
                    });

                    return isFormFullyFilled;
                }

                function isPasswordConfirmed() {
                    var errorCode = 'FRONT_END_VALIDATION_INVALID_CONFIRM_PASSWORD';

                    var newPassword = $ctrl.profile[$ctrl.fieldsConfig.newPassword.keyName];
                    var confirmPassword = $ctrl.profile[$ctrl.fieldsConfig.confirmPassword.keyName];
                    var isConsistent = newPassword === confirmPassword;

                    if (!isConsistent) {
                        $ctrl.editProfileCtrl.markFieldInvalid($ctrl.formConfig, $ctrl.fieldsConfig.confirmPassword, errorCode);
                    }

                    return isConsistent;
                }
            }],
        bindings: {
            isUserAccessible: '<'
        },
        require: {
            editProfileCtrl: '^^dpwEditProfile'
        }
    })

;
